var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var hover = _ref.hover;
        return [_c('div', {
          staticClass: "gallery-item-root"
        }, [_vm.isImage ? [_c('img', {
          staticClass: "gallery-image-img",
          attrs: {
            "src": _vm.imageUrl,
            "alt": _vm.title
          }
        })] : [_c('div', {
          staticClass: "video-tile"
        }, [_c('div', {
          staticClass: "video-thumb"
        }), _c('div', {
          staticClass: "video-play"
        }, [_c('v-icon', {
          attrs: {
            "color": "white"
          }
        }, [_vm._v("mdi-play-circle-outline")])], 1)])], _vm.showUploadProgress ? _c('div', {
          staticClass: "upload-progress"
        }, [_c('v-progress-linear', {
          attrs: {
            "height": "6",
            "rounded": "",
            "indeterminate": _vm.progressValue == null,
            "value": _vm.progressValue == null ? 0 : _vm.progressValue
          }
        })], 1) : _vm._e(), _vm.isVideoUpload ? _c('mux-uploader', {
          ref: "uploader",
          staticClass: "sr-only",
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "endpoint": _vm.videoEndpoint,
            "no-drop": "",
            "no-status": "",
            "no-retry": "",
            "aria-hidden": "true"
          },
          on: {
            "progress": _vm.onMuxProgress,
            "success": _vm.onMuxSuccess,
            "uploaderror": _vm.onMuxError
          }
        }) : _vm._e(), hover ? _c('div', {
          staticClass: "image-overlay"
        }, [_c('div', {
          staticClass: "overlay-content"
        }, [_c('div', {
          staticClass: "image-title"
        }, [_vm._v(_vm._s(_vm.title))]), _vm.detail ? _c('div', {
          staticClass: "image-type"
        }, [_vm._v(_vm._s(_vm.detail))]) : _vm._e()])]) : _vm._e()], 2)];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }